import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import ModalSelectDocument from '../controls/ModalSelectDocument';
import Tools from '../tools/tools';
import ModalMail from '../controls/ModalMail';
import ModalMailShow from '../controls/ModalMailShow';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import keycloak from '../tools/keycloak';


const RequestEmails = (props) => {
    let [data, setData] = useState();
    let [emails, setEmails] = useState();
    let [mailModalVisible, setMailModalVisible] = useState(false);
    let [mailShowModalVisible, setMailShowModalVisible] = useState(false);
    let [text, setText] = useState();
    let [receiver, setReceiver] = useState();
    let [attachments, setAttachments] = useState([]);

    const requestId = sessionStorage.getItem("requestId");

    const canBeEdited = (resultStateId) => {
        return keycloak.userInfo.preferred_username === data.givenTo;
    }


    const fetchData = async () => {
        if (!requestId) {
            return;
        }

        setEmails(null);
        Comm.Instance().get(`email?requestid=${requestId}`).then(result => {
            setEmails(result.data);

        }).catch(error => Tools.ProcessError(error));
        setData(null);
        Comm.Instance().get(`request?requestId=${requestId}`).then(result => {
            setData(result.data)

        }).catch(message => {
            toast.error(message);

        })
    };
    useEffect(() => {

        fetchData();
    }, []);

    const newLetter = (reload) => {

        setMailModalVisible(false);
        if (reload) {
            fetchData();
        }
    };

    const showMail = (emailId) => {
        setText("");
        setReceiver("");
        setAttachments([]);
        if (emailId)
            Comm.Instance().get("email/GetOne?emailId=" + emailId).then(r => {
                setText(r.data.body);
                setReceiver(r.data.receiver);
                setAttachments(r.data.attachments);
                setMailShowModalVisible(true);
            }).catch(error => Tools.ProcessError(error));



    };

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }

    if (!emails || !data)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!emails}
                />
            </div>
        );

    return (
        <>
            <div className="container">
                <h2 className="appeal-title mb-5">{data.numName} {data.name}</h2>

                <div className="form-row">
                    <div className="form-group col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        От дата
                                    </th>
                                    <th>
                                        Получател
                                    </th>
                                    <th>
                                        Потребител
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    emails.map(i =>
                                        <tr key={i.emailId}>
                                            <td>
                                                <button className="btn btn-link" onClick={() => showMail(i.emailId)}>{Tools.FormatDate(i.createdOn)}</button>

                                            </td>
                                            <td>
                                                {i.receiver}
                                            </td>
                                            <td>
                                                {i.createdBy}
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ModalMail closeFunc={(v) => newLetter(v)} requestId={requestId} display={mailModalVisible} />
            <ModalMailShow closeFunc={() => setMailShowModalVisible(false)} display={mailShowModalVisible} receiver={receiver} text={text} attachments={attachments} />

            <div className="container">
                {canBeEdited(data.requestStateId) ? <button type="button" className="btn btn-primary" onClick={() => setMailModalVisible(true)}>Ново писмо</button> : null}
            </div>

        </>

    );
}


export default RequestEmails;

